import CircleLoader from "../CircleLoader.jsx";
import React from "react";
import Input from "../Input.jsx";
import Button from "../Button.jsx";
import GoogleSignInButton from "../GoogleSignInButton.jsx";


export default function LoginContent({
	                                     email,
	                                     password,
	                                     showPassword,
	                                     submitting,
	                                     error,
	                                     googleSignInError,
	                                     googleSigningIn,
	                                     currentTab,
	                                     inputChange,
	                                     forgotPasswordNavigate,
	                                     onGoogleSignIn,
	                                     onGoogleSignInFailure,
	                                     onSubmit
                                     }) {

	const isLogin = currentTab === 'log-in';
	const isSignUp = currentTab === 'sign-up';

	if(googleSigningIn) {
		return (
			<div>
				<div>
					<h3 className='center'>Signing In With Google...</h3>
					<CircleLoader
					/>
				</div>
			</div>
		);
	}

	return (
		<React.Fragment>
			<div className='row'>
				<form
					onSubmit={onSubmit}
					className='col s12'
					method='post'
				>
					<div className='row'>
						<div className='col s12'>
						</div>
					</div>

					<div className='row'>
						<div className='input-field col s12'>
							<Input
								disabled={submitting}
								onChange={inputChange}
								value={email}
								className='validate'
								type='email'
								name='email'
								autoComplete='username'
								id='email'
							/>
							<label htmlFor='email'>Enter your email</label>
						</div>
					</div>

					<div className='row'>
						<div className='input-field col s12'>
							<Input
								disabled={submitting}
								onChange={inputChange}
								value={password}
								className='validate'
								type={showPassword ? 'text' : 'password'}
								name='password'
								id='password'
								autoComplete={isSignUp ? 'new-password' : 'current-password'}
							/>
							<label
								htmlFor='password'>{isSignUp ? 'Create a new password' : 'Enter your password'}</label>
							{isSignUp &&
							<div className='hint_text'>
								At Least 8 Characters
							</div>
							}
						</div>
					</div>

					{error &&
					<div className='error'>
						{error}
					</div>
					}

					<br />
					<div className='row'>
						<div className='col s12'>
							<Button
								block
								disabled={submitting}
								type='submit'
								name='btn_login'
							>
								{isSignUp ? 'Create New Account' : 'Log In'}
							</Button>
						</div>
					</div>
					<div className='row'>
						<div className='col s12 left-align'>
							<a
								onClick={forgotPasswordNavigate}
							>
								Forgot Password?
							</a>
						</div>
					</div>
				</form>
			</div>
			<div className='row'>
				<div className='col s12'>
					<GoogleSignInButton
						onSignIn={onGoogleSignIn}
						onFailure={onGoogleSignInFailure}
					/>

					{!!googleSignInError &&
					<div className='error'>
						{googleSignInError}
					</div>
					}
				</div>
			</div>
		</React.Fragment>
	);
}